import { Bold } from 'almanac-ui/icons/16'
import { useBoldToggle } from 'common/Prose/Toolbar/hooks/useBoldToggle'
import { InlineFormatButton } from 'components/InlineFormatBar/components/InlineFormatButton/InlineFormatButton'
import { observer } from 'mobx-react-lite'
import { EditorView } from 'prosemirror-view'

export const BoldInlineFormatButton = observer(function BoldInlineFormatButton({ view }: { view: EditorView }) {
  const { active, disabled, handleClick } = useBoldToggle(view)

  return (
    <InlineFormatButton
      data-testid="Toggle bold"
      aria-label="Toggle bold"
      label="Bold"
      shortcutKeys="b"
      shortcutModifiers={['Mod']}
      onPress={handleClick}
      active={active}
      isDisabled={disabled}
    >
      <Bold />
    </InlineFormatButton>
  )
})
